<script setup lang="ts">
import { onMounted, ref, watch, type Ref } from 'vue'
import Section from '@/components/main/Section.vue'
import SectionContact from '@/components/main/SectionContact.vue'
import SectionHours from '@/components/main/SectionHours.vue'
import stores from '@/storage/stores'
import Copyright from './footer/Copyright.vue'
import { theme } from '@/event/theme/theme'
import SectionDetails from './footer/SectionDetails.vue'
</script>

<template>
    <footer class="" :class="{}">
        <SectionDetails v-if="theme === 'default'" />
        <Copyright v-if="theme === 'default'" />
    </footer>
</template>

<style scoped>
footer {
    @apply w-full pt-4;
}
</style>
